<div class="hero-media" aria-hidden="true">
    <img ngSrc="/images/home/veyora-fit-hero.webp" fill priority alt="">
</div>
<div class="hero-shade" aria-hidden="true"></div>

<div class="content">
    <p class="eyebrow" showleft [showDelay]="0">Veyora Fit Studio Essentials</p>
    <h1 showleft [showDelay]="80">Made to move. Styled to live in.</h1>
    <p class="summary" showleft [showDelay]="160">Supportive sets, sculpting leggings, and lightweight layers that
        carry you from workouts to everything after.</p>
    <div class="actions" showleft [showDelay]="240">
        <a matButton="filled" routerLink="/search" aria-label="Shop Veyora Fit activewear">Shop Activewear</a>
        <a matButton="outlined" routerLink="/collection/{{bestSellerNo}}"
            aria-label="Explore Veyora Fit best sellers">Best Sellers</a>
    </div>
    <div class="signals" showleft [showDelay]="320">
        <span>Soft support</span>
        <span>Sculpted stretch</span>
        <span>Easy layers</span>
    </div>
</div>